
export const successPopup = (successful = true) => {
	let timerInterval
	Bandwango.helpers('swal', {
		title: successful ? 'Your content is being created...' : 'Something went wrong:',
		html: successful ? 'Enjoy your day!' : 'Try again or talk to an admin if the error continues.',
		timer: 2500,
		timerProgressBar: true,
		didOpen: () => {
			Bandwango.helpers('swal').showLoading()
			timerInterval = setInterval(() => {
				const content = Bandwango.helpers('swal').getContent()
				if (content) {
					const b = content.querySelector('b')
					if (b) {
						b.textContent = Bandwango.helpers('swal').getTimerLeft()
					}
				}
			}, 100)
		},
		willClose: () => {
			clearInterval(timerInterval)
		}
	})
}